import Vue from "vue";
import VueRouter from "vue-router";

import Login from "../views/authorize/login";
import Dashboard from "./../views/dashboard";

import ListCustomerGroup from "./../views/customer/customer-group/list";
import CreateCustomerGroup from "./../views/customer/customer-group/create";
import EditCustomerGroup from "./../views/customer/customer-group/edit";

import ListCustomer from "./../views/customer/list-customer/list";
import EditCustomer from "./../views/customer/list-customer/edit";
import DetailCustomer from "./../views/customer/list-customer/detail";

import ListRole from "./../views/the-settings/role/list";
import CreateRole from "./../views/the-settings/role/create";
import EditRole from "./../views/the-settings/role/edit";

import ListAdminAccount from "./../views/the-settings/account/list";
import CreateAdminAccount from "./../views/the-settings/account/create";
import UpdateAdminAccount from "./../views/the-settings/account/update";

import Profile from "./../views/the-settings/profile";

import ListAdvertisement from "../views/campaign/advertisement/list";
import CreateAdvertisement from "../views/campaign/advertisement/create";
import EditAdvertisement from "../views/campaign/advertisement/edit";

import ListBrand from "./../views/catalog/brand/list";
import CreateBrand from "./../views/catalog/brand/create";
import EditBrand from "./../views/catalog/brand/edit";

import ListStockStatus from "../views/catalog/stock-status/list";
import CreateStockStatus from "../views/catalog/stock-status/create";
import EditStockStatus from "../views/catalog/stock-status/edit";

import ListOption from "../views/catalog/option/list";
import CreateOption from "../views/catalog/option/create";
import EditOption from "../views/catalog/option/edit";

import CreateOptionValue from "../views/catalog/option-value/create";
import EditOptionValue from "../views/catalog/option-value/edit";

import ListCoupon from "../views/catalog/coupon/list";
import CreateCoupon from "../views/catalog/coupon/create";
import EditCoupon from "../views/catalog/coupon/edit";

import ListManufacturer from "../views/catalog/manufaturer/list";
import CreateManufacturer from "../views/catalog/manufaturer/create";
import EditManufacturer from "../views/catalog/manufaturer/edit";

import ListTopSelection from "../views/catalog/top-selection/list";
import CreateTopSelection from "../views/catalog/top-selection/create";

import ListUnitOfMeasure from "../views/catalog/unit-of-measure/list";
import CreateUnitOfMeasure from "../views/catalog/unit-of-measure/create";
import EditUnitOfMeasure from "../views/catalog/unit-of-measure/edit";

import ListProduct from "../views/catalog/product/list";
import EditProduct from "../views/catalog/product/edit";
import EditVaraint from "../components/catalog/product/edit/edit-variant";

import ListProductDiscount from "../views/catalog/product-discount/list";
import CreateProductDiscount from "../views/catalog/product-discount/create";
import EditProductDiscount from "../views/catalog/product-discount/edit";

import ListCategory from "./../views/catalog/category/list";
import CreateCategory from "./../views/catalog/category/create";
import EditCategory from "./../views/catalog/category/edit";

import EditSubcategory from "./../views/catalog/category/subcategory/edit";

import ListPointExchange from "./../views/point/point-exchange/list";

import ListMerchandise from "./../views/point/merchandise/list";
import CreateMerchandise from "./../views/point/merchandise/create";
import EditMerchandise from "./../views/point/merchandise/edit";

import ListVoucherTheme from "./../views/voucher/voucher-theme/list";
import CreateVoucherTheme from "./../views/voucher/voucher-theme/create";
import EditVoucherTheme from "./../views/voucher/voucher-theme/edit";

import ListVoucher from "./../views/voucher/voucher/list";
import CreateVoucher from "./../views/voucher/voucher/create";
import EditVoucher from "./../views/voucher/voucher/edit";

import ListPaymentMethod from "./../views/payment/payment-method/list";
import CreatePaymentMethod from "./../views/payment/payment-method/create";
import EditPaymentMethod from "./../views/payment/payment-method/edit";

import ListCurrency from "./../views/payment/currency/list";
import CreateCurrency from "./../views/payment/currency/create";
import EditCurrency from "./../views/payment/currency/edit";

import ListTicketType from "./../views/ticket/ticket-type/list";
import CreateTicketType from "./../views/ticket/ticket-type/create";
import EditTicketType from "./../views/ticket/ticket-type/edit";
import CreateSubTicketType from "./../views/ticket/ticket-type/sub-ticket-type/create";

import ListNotification from "../views/campaign/notification/list";
import CreateNotification from "../views/campaign/notification/create";
import EditNotification from "../views/campaign/notification/edit";

import ListPopupBanner from "../views/campaign/popup-banner/list";
import CreatePopupBanner from "../views/campaign/popup-banner/create";
import EditPopupBanner from "../views/campaign/popup-banner/edit";

import ListLanguage from "./../views/language/list";

import ListGeoZone from "./../views/address/geo-zone/list";
import CreateGeoZone from "./../views/address/geo-zone/create";
import EditGeoZone from "./../views/address/geo-zone/edit";

import ListZoneToGeoZone from "./../views/address/zone-to-geozone/list";
import CreateZoneToGeoZone from "./../views/address/zone-to-geozone/create";
import EditZoneToGeoZone from "./../views/address/zone-to-geozone/edit";

// review
import ListProductReview from "../views/review/product-showroom/list";
import EditProductReview from "../views/review/product-showroom/edit";
import ListCustomerFeedback from "../views/review/customer-feedback/list";
import EditCustomerFeedback from "../views/review/customer-feedback/edit";

import ListReportCustomer from "../views/report/customer";
import ListReportOrder from "../views/report/order";
import ListReportServiceTicket from "../views/report/service-ticket";
import ListReportAcademyTicket from "../views/report/academy-ticket";
import ListReportTrainingTicket from "../views/report/training-ticket";

import ListAppVersion from "../views/the-settings/app-version/list";

import ListSettings from "../views/the-settings/settings/list";
import ListSpecialBlendSetting from "../views/the-settings/special-blend/list";

import ListTutorialPlaylist from "../views/tutorial/Tutorial-playlist/list";
import CreateTutorialPlaylist from "../views/tutorial/Tutorial-playlist/create";
import EditTutorialPlaylist from "../views/tutorial/Tutorial-playlist/edit";

import ListTutorialVideo from "../views/tutorial/tutorial-video/list";
import CreateTutorialVideo from "../views/tutorial/tutorial-video/create";
import EditTutorialVideo from "../views/tutorial/tutorial-video/edit";

import ListShowroom from "../views/showroom/list";
import CreateShowroom from "../views/showroom/create";
import EditShowroom from "../views/showroom/edit";

import ListShipping from "../views/shipping/list";
import CreateShipping from "../views/shipping/create";
import EditShipping from "../views/shipping/edit";

import ListOrder from "../views/order/order/list";
import EditOrder from "../views/order/order/edit";

import ListOrderStatus from "../views/order/order-status/list";
import ListQuotation from "../views/order/quotation/list";
import DetailQuotation from "../views/order/quotation/detail";

import ListSpecialBlend from "../views/catalog/special-blend/list";
import EditSpecialBlend from "../views/catalog/special-blend/edit";

import ListSpecialBlendOrder from "../views/order/special-blend-order/list";
import EditSpecialBlendOrder from "../views/order/special-blend-order/edit";

import ListWarehouse from "../views/warehouses/warehouse/list";
import EditWarehouse from "../views/warehouses/warehouse/edit";
import CreateWarehouse from "../views/warehouses/warehouse/create";

import ListBranch from "../views/warehouses/branch/list";
import EditBranch from "../views/warehouses/branch/edit";
import CreateBranch from "../views/warehouses/branch/create";

import ListDeliveryCondition from "../views/deliveries/delivery-condition/list";
import EditDeliveryCondition from "../views/deliveries/delivery-condition/edit";
import CreateDeliveryCondition from "../views/deliveries/delivery-condition/create";

import ListDeliveryFeeBranch from "../views/deliveries/delivery-branch/list";
import EditDeliveryFeeBranch from "../views/deliveries/delivery-branch/edit";
import CreateDeliveryFeeBranch from "../views/deliveries/delivery-branch/create";

import ListDeliveryFeeDistrict from "../views/deliveries/delivery-district/list";
import EditDeliveryFeeDistrict from "../views/deliveries/delivery-district/edit";
import CreateDeliveryFeeDistrict from "../views/deliveries/delivery-district/create";

import ListEWarrantyCard from "../views/ticket/e-warranty-card";

import ListCheckupRequest from "../views/ticket/checkup-request/list";
import EditCheckupRequest from "../views/ticket/checkup-request/edit";

import ListServicePackage from "../views/ticket/service-package/list";
import EditServicePackage from "../views/ticket/service-package/edit";

import ListBaristaRequest from "../views/ticket/barista-request/list";
import EditBaristaRequest from "../views/ticket/barista-request/edit";

import ListTrainingCourse from "../views/ticket/training-course/list";
import EditTrainingCourse from "../views/ticket/training-course/edit";

// not found page
import NotFound from "../views/authorize/404-page";

import ListPromotion from "../views/campaign/promotion/list";
import UpdatePromotion from "../views/campaign/promotion/edit";
import CreatePromotion from "../views/campaign/promotion/create";
import helper from "../utils/api/helper";
// =============================================================

const isLoggedIn = (_, __, next) => {
  let token = localStorage.getItem(helper?.tokenEnum()?.access_token)
    ? localStorage.getItem(helper?.tokenEnum()?.access_token)
    : "";

  if (!token) {
    return router.push({
      name: "login",
    });
  }
  return next();
};

const isNotLoggedIn = (_, __, next) => {
  let token = localStorage.getItem(helper?.tokenEnum()?.access_token)
    ? localStorage.getItem(helper?.tokenEnum()?.access_token)
    : "";

  if (token) {
    return router.push({
      name: "dashboard",
    });
  }
  return next();
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login,
    beforeEnter: isNotLoggedIn,
  },
  {
    path: "/",
    name: "dashboard",
    component: Dashboard,
    beforeEnter: isLoggedIn,
  },

  // ==== customer =====
  {
    path: "/customer/customer",
    name: "ListCustomer",
    component: ListCustomer,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/customer/customer/update",
    name: "EditCustomer",
    component: EditCustomer,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/customer/customer/detail",
    name: "DetailCustomer",
    component: DetailCustomer,
    beforeEnter: isLoggedIn,
  },

  //==== customer group =====
  {
    path: "/customer/customer-group",
    name: "ListCustomerGroup",
    component: ListCustomerGroup,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/customer/customer-group/create",
    name: "CreateCustomerGroup",
    component: CreateCustomerGroup,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/customer/customer-group/update",
    name: "EditCustomerGroup",
    component: EditCustomerGroup,
    beforeEnter: isLoggedIn,
  },

  // campaign
  {
    path: "/campaign/advertisement",
    name: "ListAdvertisement",
    component: ListAdvertisement,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/campaign/advertisement/create",
    name: "CreateAdvertisement",
    component: CreateAdvertisement,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/campaign/advertisement/update",
    name: "EditAdvertisement",
    component: EditAdvertisement,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/campaign/promotion",
    name: "ListPromotion",
    component: ListPromotion,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/campaign/promotion/create",
    name: "CreatePromotion",
    component: CreatePromotion,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/campaign/promotion/update",
    name: "UpdatePromotion",
    component: UpdatePromotion,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/campaign/notification",
    name: "ListNotification",
    component: ListNotification,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/campaign/notification/create",
    name: "CreateNotification",
    component: CreateNotification,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/campaign/notification/update",
    name: "EditNotification",
    component: EditNotification,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/campaign/popup-banner",
    name: "ListPopupBanner",
    component: ListPopupBanner,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/campaign/popup-banner/create",
    name: "CreatePopupBanner",
    component: CreatePopupBanner,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/campaign/popup-banner/update",
    name: "EditPopupBanner",
    component: EditPopupBanner,
    beforeEnter: isLoggedIn,
  },

  // catalog
  {
    path: "/catalog/brand",
    name: "ListBrand",
    component: ListBrand,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/brand/create",
    name: "CreateBrand",
    component: CreateBrand,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/brand/update",
    name: "EditBrand",
    component: EditBrand,
    beforeEnter: isLoggedIn,
  },

  {
    path: "/catalog/stock-status",
    name: "ListStockStatus",
    component: ListStockStatus,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/stock-status/create",
    name: "CreateStockStatus",
    component: CreateStockStatus,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/stock-status/update",
    name: "EditStockStatus",
    component: EditStockStatus,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/option",
    name: "ListOption",
    component: ListOption,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/option/create",
    name: "CreateOption",
    component: CreateOption,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/option/update",
    name: "EditOption",
    component: EditOption,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/option-value/create",
    name: "CreateOptionValue",
    component: CreateOptionValue,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/option-value/update",
    name: "EditOptionValue",
    component: EditOptionValue,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/coupon",
    name: "ListCoupon",
    component: ListCoupon,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/coupon/create",
    name: "CreateCoupon",
    component: CreateCoupon,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/coupon/update",
    name: "EditCoupon",
    component: EditCoupon,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/manufacturer",
    name: "ListManufacturer",
    component: ListManufacturer,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/manufacturer/create",
    name: "CreateManufacturer",
    component: CreateManufacturer,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/manufacturer/update",
    name: "EditManufacturer",
    component: EditManufacturer,
    beforeEnter: isLoggedIn,
  },

  // Top Selection
  {
    path: "/catalog/top-selection",
    name: "ListTopSelection",
    component: ListTopSelection,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/top-selection/create",
    name: "CreateTopSelection",
    component: CreateTopSelection,
    beforeEnter: isLoggedIn,
  },

  // Unit of Measure
  {
    path: "/catalog/unit-of-measure",
    name: "ListUnitOfMeasure",
    component: ListUnitOfMeasure,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/unit-of-measure/create",
    name: "CreateUnitOfMeasure",
    component: CreateUnitOfMeasure,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/unit-of-measure/update",
    name: "EditUnitOfMeasure",
    component: EditUnitOfMeasure,
    beforeEnter: isLoggedIn,
  },

  // Product
  {
    path: "/catalog/product",
    name: "ListProduct",
    component: ListProduct,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/product/update",
    name: "EditProduct",
    component: EditProduct,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/special-blend",
    name: "ListSpecialBlend",
    component: ListSpecialBlend,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/special-blend/update",
    name: "EditSpecialBlend",
    component: EditSpecialBlend,
    beforeEnter: isLoggedIn,
  },

  {
    path: "/catalog/product/varaint/update",
    name: "EditVaraint",
    component: EditVaraint,
    beforeEnter: isLoggedIn,
  },

  {
    path: "/catalog/product-discount",
    name: "ListProductDiscount",
    component: ListProductDiscount,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/product-discount/create",
    name: "CreateProductDiscount",
    component: CreateProductDiscount,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/product-discount/update",
    name: "EditProductDiscount",
    component: EditProductDiscount,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/category",
    name: "ListCategory",
    component: ListCategory,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/category/create",
    name: "CreateCategory",
    component: CreateCategory,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/catalog/category/update",
    name: "EditCategory",
    component: EditCategory,
    beforeEnter: isLoggedIn,
  },

  {
    path: "/catalog/category/subcategory/update",
    name: "EditSubcategory",
    component: EditSubcategory,
    beforeEnter: isLoggedIn,
  },

  //========== Point and Merchandise
  {
    path: "/point-and-merchandise/point-exchange",
    name: "ListPointExchange",
    component: ListPointExchange,
    beforeEnter: isLoggedIn,
  },

  {
    path: "/point-and-merchandise/merchandise",
    name: "ListMerchandise",
    component: ListMerchandise,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/point-and-merchandise/merchandise/create",
    name: "CreateMerchandise",
    component: CreateMerchandise,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/point-and-merchandise/merchandise/update",
    name: "EditMerchandise",
    component: EditMerchandise,
    beforeEnter: isLoggedIn,
  },

  //========== Point and Merchandise

  //====== Voucher Theme and Voucher ===========
  {
    path: "/voucher/theme",
    name: "ListVoucherTheme",
    component: ListVoucherTheme,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/voucher/theme/create",
    name: "CreateVoucherTheme",
    component: CreateVoucherTheme,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/voucher/theme/update",
    name: "EditVoucherTheme",
    component: EditVoucherTheme,
    beforeEnter: isLoggedIn,
  },

  {
    path: "/voucher",
    name: "ListVoucher",
    component: ListVoucher,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/voucher/create",
    name: "CreateVoucher",
    component: CreateVoucher,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/voucher/update",
    name: "EditVoucher",
    component: EditVoucher,
    beforeEnter: isLoggedIn,
  },
  //======= Voucher Theme and Voucher =======

  //====== Payment Method and Currency ===========
  {
    path: "/payment/payment-method",
    name: "ListPaymentMethod",
    component: ListPaymentMethod,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/payment/payment-method/create",
    name: "CreatePaymentMethod",
    component: CreatePaymentMethod,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/payment/payment-method/update",
    name: "EditPaymentMethod",
    component: EditPaymentMethod,
    beforeEnter: isLoggedIn,
  },

  {
    path: "/payment/currency",
    name: "ListCurrency",
    component: ListCurrency,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/payment/currency/create",
    name: "CreateCurrency",
    component: CreateCurrency,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/payment/currency/update",
    name: "EditCurrency",
    component: EditCurrency,
    beforeEnter: isLoggedIn,
  },
  //======= Payment Method and Currency =======

  //======== Ticket Type ==============
  {
    path: "/ticket/ticket-type",
    name: "ListTicketType",
    component: ListTicketType,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/ticket/ticket-type/create",
    name: "CreateTicketType",
    component: CreateTicketType,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/ticket/ticket-type/update",
    name: "EditTicketType",
    component: EditTicketType,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/ticket/sub-ticket-type/create",
    name: "CreateSubTicketType",
    component: CreateSubTicketType,
    beforeEnter: isLoggedIn,
  },

  // Ticket
  {
    path: "/ticket/e-warranty-card",
    name: "ListEWarrantyCard",
    component: ListEWarrantyCard,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/ticket/checkup-request",
    name: "ListCheckupRequest",
    component: ListCheckupRequest,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/ticket/checkup-request/detail/:id",
    name: "EditCheckupRequest",
    component: EditCheckupRequest,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/ticket/service-package",
    name: "ListServicePackage",
    component: ListServicePackage,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/ticket/service-package/detail/:id",
    name: "EditServicePackage",
    component: EditServicePackage,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/ticket/barista-request",
    name: "ListBaristaRequest",
    component: ListBaristaRequest,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/ticket/barista-request/detail/:id",
    name: "EditBaristaRequest",
    component: EditBaristaRequest,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/ticket/training-course",
    name: "ListTrainingCourse",
    component: ListTrainingCourse,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/ticket/training-course/detail/:id",
    name: "EditTrainingCourse",
    component: EditTrainingCourse,
    beforeEnter: isLoggedIn,
  },
  //======== End Ticket =========

  // Geo zone
  {
    path: "/address/geo-zone",
    name: "ListGeoZone",
    component: ListGeoZone,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/address/geo-zone/create",
    name: "CreateGeoZone",
    component: CreateGeoZone,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/address/geo-zone/update",
    name: "EditGeoZone",
    component: EditGeoZone,
    beforeEnter: isLoggedIn,
  },

  //Zone to geo zone
  {
    path: "/address/zone-to-geo-zone",
    name: "ListZoneToGeoZone",
    component: ListZoneToGeoZone,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/address/zone-to-geo-zone/create",
    name: "CreateZoneToGeoZone",
    component: CreateZoneToGeoZone,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/address/zone-to-geo-zone/update",
    name: "EditZoneToGeoZone",
    component: EditZoneToGeoZone,
  },

  //Review
  {
    path: "/review/product-showroom",
    name: "ListProductReview",
    component: ListProductReview,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/review/product-showroom/update",
    name: "EditProductReview",
    component: EditProductReview,
    beforeEnter: isLoggedIn,
    props: true,
  },

  {
    path: "/review/customer-feedback",
    name: "ListCustomerFeedback",
    component: ListCustomerFeedback,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/review/customer-feedback/detail/:id",
    name: "EditCustomerFeedback",
    component: EditCustomerFeedback,
    beforeEnter: isLoggedIn,
    props: true,
  },

  // Report
  {
    path: "/report/customer",
    name: "ListReportCustomer",
    component: ListReportCustomer,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/report/order",
    name: "ListReportOrder",
    component: ListReportOrder,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/report/service-ticket-report",
    name: "ListReportServiceTicket",
    component: ListReportServiceTicket,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/report/academy-ticket-report",
    name: "ListReportAcademyTicket",
    component: ListReportAcademyTicket,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/report/training-ticket-report",
    name: "ListReportTrainingTicket",
    component: ListReportTrainingTicket,
    beforeEnter: isLoggedIn,
  },

  // Settings
  {
    path: "/setting/app-version",
    name: "ListAppVersion",
    component: ListAppVersion,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/setting/language",
    name: "Language",
    component: ListLanguage,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/setting/system-setting",
    name: "ListSettings",
    component: ListSettings,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/setting/special-blend-setting",
    name: "ListSpecialBlendSetting",
    component: ListSpecialBlendSetting,
    beforeEnter: isLoggedIn,
  },

  // setting
  {
    path: "/setting/role-management",
    name: "ListRole",
    component: ListRole,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/setting/role-management/create",
    name: "CreateRole",
    component: CreateRole,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/setting/role-management/update",
    name: "EditRole",
    component: EditRole,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/setting/admin-management",
    name: "ListAdminAccount",
    component: ListAdminAccount,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/setting/admin-management/create",
    name: "CreateAdminAccount",
    component: CreateAdminAccount,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/setting/admin-management/update/:id",
    name: "UpdateAdminAccount",
    component: UpdateAdminAccount,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/setting/profile",
    name: "Profile",
    component: Profile,
    beforeEnter: isLoggedIn,
  },

  // Tutorial playlist
  {
    path: "/tutorial/tutorial-playlist",
    name: "ListTutorialPlaylist",
    component: ListTutorialPlaylist,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/tutorial/tutorial-playlist/create",
    name: "CreateTutorialPlaylist",
    component: CreateTutorialPlaylist,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/tutorial/tutorial-playlist/edit",
    name: "EditTutorialPlaylist",
    component: EditTutorialPlaylist,
    beforeEnter: isLoggedIn,
  },
  // Tutorial video
  {
    path: "/tutorial/tutorial-video",
    name: "ListTutorialVideo",
    component: ListTutorialVideo,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/tutorial/tutorial-video/create",
    name: "CreateTutorialVideo",
    component: CreateTutorialVideo,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/tutorial/tutorial-video/edit",
    name: "EditTutorialVideo",
    component: EditTutorialVideo,
    beforeEnter: isLoggedIn,
  },

  // Showroom
  {
    path: "/showroom",
    name: "ListShowroom",
    component: ListShowroom,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/showroom/create",
    name: "CreateShowroom",
    component: CreateShowroom,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/showroom/edit",
    name: "EditShowroom",
    component: EditShowroom,
    beforeEnter: isLoggedIn,
  },

  // Shipping
  {
    path: "/shipping",
    name: "ListShipping",
    component: ListShipping,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/shipping/create",
    name: "CreateShipping",
    component: CreateShipping,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/shipping/edit",
    name: "EditShipping",
    component: EditShipping,
    beforeEnter: isLoggedIn,
  },

  // Order
  {
    path: "/order/normal-order",
    name: "ListOrder",
    component: ListOrder,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/order/normal-order/edit",
    name: "EditOrder",
    component: EditOrder,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/order/special-blend-order",
    name: "ListSpecialBlendOrder",
    component: ListSpecialBlendOrder,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/order/special-blend-order/edit",
    name: "EditSpecialBlendOrder",
    component: EditSpecialBlendOrder,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/order/order-status",
    name: "ListOrderStatus",
    component: ListOrderStatus,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/order/order-quotation",
    name: "ListQuotation",
    component: ListQuotation,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/order/order-quotation/:id",
    name: "DetailQuotation",
    component: DetailQuotation,
    beforeEnter: isLoggedIn,
  },

  // warehouse
  {
    path: "/warehouse/warehouse",
    name: "ListWarehouse",
    component: ListWarehouse,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/warehouse/warehouse/edit",
    name: "EditWarehouse",
    component: EditWarehouse,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/warehouse/warehouse/create",
    name: "CreateWarehouse",
    component: CreateWarehouse,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/warehouse/branch",
    name: "ListBranch",
    component: ListBranch,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/warehouse/branch/update",
    name: "EditBranch",
    component: EditBranch,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/warehouse/branch/create",
    name: "CreateBranch",
    component: CreateBranch,
    beforeEnter: isLoggedIn,
  },

  // deliveries
  {
    path: "/delivery/delivery-condition",
    name: "ListDeliveryCondition",
    component: ListDeliveryCondition,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/delivery/delivery-condition/edit",
    name: "EditDeliveryCondition",
    component: EditDeliveryCondition,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/delivery/delivery-condition/create",
    name: "CreateDeliveryCondition",
    component: CreateDeliveryCondition,
    beforeEnter: isLoggedIn,
  },

  {
    path: "/delivery/delivery-branch",
    name: "ListDeliveryFeeBranch",
    component: ListDeliveryFeeBranch,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/delivery/delivery-branch/edit",
    name: "EditDeliveryFeeBranch",
    component: EditDeliveryFeeBranch,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/delivery/delivery-branch/create",
    name: "CreateDeliveryFeeBranch",
    component: CreateDeliveryFeeBranch,
    beforeEnter: isLoggedIn,
  },

  {
    path: "/delivery/delivery-district",
    name: "ListDeliveryFeeDistrict",
    component: ListDeliveryFeeDistrict,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/delivery/delivery-district/edit",
    name: "EditDeliveryFeeDistrict",
    component: EditDeliveryFeeDistrict,
    beforeEnter: isLoggedIn,
  },
  {
    path: "/delivery/delivery-district/create",
    name: "CreateDeliveryFeeDistrict",
    component: CreateDeliveryFeeDistrict,
    beforeEnter: isLoggedIn,
  },

  // not found
  {
    path: "/:pathMatch(.*)*",
    component: NotFound,
    beforeEnter: isLoggedIn,
  },
];

// Preserve original push method
const originalPush = VueRouter.prototype.push;

// Override push method
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  // Clean query if it exists
  if (location && typeof location === "object" && location.query) {
    location.query = Object.fromEntries(
      Object.entries(location.query).filter(
        // eslint-disable-next-line no-unused-vars
        ([_, value]) => value !== null && value !== undefined && value !== ""
      )
    );
  }

  // Support optional callbacks
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }

  // Catch NavigationDuplicated error and suppress it
  return originalPush.call(this, location).catch((err) => err);
};

// create router instance
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
